import { resetAuthUser_actionType, setAuthUser_actionType } from "../constants";

const initialState = null;

// const initialState = false
const authUser = (state = initialState, action) => {
  switch (action.type) {
    case setAuthUser_actionType: {
      const { payload } = action;

      return payload;
    }
    case resetAuthUser_actionType: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default authUser;
